<page-toolbar [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProvider]="angieCustomersService" [title]="title"></data-table>
</page-content>
